export const gUiWidgetDimensionsConstraints = Object.freeze({
  'label' : {minHeight: 1, maxHeight: 5, minWidth : 2, maxWidth: 8},
  'eventButton' : {minHeight: 1, maxHeight: 5, minWidth : 1, maxWidth: 8},
  'variableDisplay' : {minHeight: 1, maxHeight: 1, minWidth : 2, maxWidth: 8},
  'digitalInputDisplay' : {minHeight: 1, maxHeight: 1, minWidth : 2, maxWidth: 8},
  'console' : {minHeight: 2, maxHeight: 5, minWidth : 6, maxWidth: 8},
  'dropdown' : {minHeight: 1, maxHeight: 1, minWidth : 2, maxWidth: 8},
  'numericInput' : {minHeight: 1, maxHeight: 1, minWidth : 2, maxWidth: 8},
  'custom': {minHeight: 1, maxHeight: 8, minWidth: 1, maxWidth: 8}
});
